import { useState } from 'react';
import { Link as RouterLink, useHistory } from 'react-router-dom';
import Typography from '@mui/material/Typography';
import {
  Box,
  FormControl,
  FormHelperText,
  IconButton,
  Input,
  InputAdornment,
  InputLabel,
  Link,
} from '@mui/material';
import {
  ArrowForwardRounded,
  LockRounded,
  PersonRounded,
  VisibilityOffRounded,
  VisibilityRounded,
} from '@mui/icons-material';
import { useForm } from 'react-hook-form';
import { useUser } from '../User';
import CustomizedSnackbars from '../../Notifications/SnackBar';
import { LoadingButton } from '@mui/lab';
import ButtonDownloadPWA from '../../../@iosper/components/PWA/ButtonDownloadPWA';
import { ButtonDownloadPWAiOS } from '../../../@iosper/components/PWA/ButtonDownloadPWAiOS';
import { BotonDescargaApp } from './BotonDescargaApp';

export const LoginFormMobile = () => {
  const { signIn } = useUser();
  const [response, setResponse] = useState('');
  const [loading, setLoading] = useState(false);
  const history = useHistory();
  const [showPassword, setShowPassword] = useState(false);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({ mode: 'onSubmit' });

  const signInHandler = async (data, e) => {
    setLoading(true);
    e.preventDefault();
    setResponse('');
    signInEvent(data.username, data.password);
  };

  const signInEvent = async (username, password) => {
    const res = await signIn(username, password);
    if (res) {
      setLoading(false);
      setResponse('Ingresando a Mi OSER...');
      history.push('/');
    } else {
      setLoading(false);
    }
  };

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const handleBorrarMensaje = () => {
    setResponse('');
  };

  return (
    <>
      <form noValidate onSubmit={handleSubmit(signInHandler)} style={{ width: '100%' }}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: 2,
            background: '#fff',
            padding: '32px 24px',
            borderRadius: '8px',
          }}
        >
          {/* <Typography variant='h1' fontSize={'1.97rem'} fontWeight={'400'} align='center'>
            Iniciar Sesión
          </Typography> */}

          {/* <Divider /> */}

          <FormControl fullWidth error={!!errors.username} variant='standard'>
            <InputLabel htmlFor='username'>CUIL o Nº Afiliado</InputLabel>
            <Input
              variant='standard'
              required
              fullWidth
              id='username'
              name='username'
              autoComplete='username'
              startAdornment={
                <InputAdornment position='start'>
                  <PersonRounded />
                </InputAdornment>
              }
              inputProps={{
                inputMode: 'numeric',
              }}
              sx={{
                '& input::placeholder': {
                  opacity: 0.9, // Crucial para que no se vea tenue
                },
              }}
              {...register('username', {
                required: {
                  value: true,
                  message: 'Debe ingresar CUIL o N° Afiliado',
                },
              })}
            />
            <FormHelperText error={!!errors.username}>
              {errors.username ? errors.username.message : ''}
            </FormHelperText>
          </FormControl>

          <FormControl variant='standard' fullWidth error={!!errors.password}>
            <InputLabel htmlFor='password'>Contraseña/PIN</InputLabel>
            <Input
              id='password'
              type={showPassword ? 'text' : 'password'}
              name='password'
              sx={{
                '& input::placeholder': {
                  opacity: 0.9, // Crucial para que no se vea tenue
                },
              }}
              startAdornment={
                <InputAdornment position='start'>
                  <LockRounded />
                </InputAdornment>
              }
              endAdornment={
                <InputAdornment position='end'>
                  <IconButton
                    aria-label='toggle password visibility'
                    onClick={handleClickShowPassword}
                    onMouseDown={handleMouseDownPassword}
                  >
                    {showPassword ? <VisibilityOffRounded /> : <VisibilityRounded />}
                  </IconButton>
                </InputAdornment>
              }
              {...register('password', {
                required: {
                  value: true,
                  message: 'Debe ingresar contraseña/PIN',
                },
              })}
            />
            <FormHelperText error={!!errors.password}>
              {errors.password ? errors.password.message : ''}
            </FormHelperText>
          </FormControl>

          <Link
            component={RouterLink}
            to={'/olvide-pin-mobile'}
            variant='text'
            size='medium'
            color='primary'
            underline='none'
            sx={{
              fontSize: '0.85rem',
              width: 'max-content',
            }}
          >
            Olvide mi Contraseña/PIN
          </Link>

          <FormControl>
            <LoadingButton
              variant='contained'
              size='medium'
              color='primary'
              endIcon={<ArrowForwardRounded />}
              loading={loading}
              disabled={loading}
              type='submit'
              disableElevation
            >
              Ingresar
            </LoadingButton>
          </FormControl>
        </Box>
      </form>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        {/* <Typography variant='h7' component='h6' align='center'>
          ¿No tenés cuenta en Mi OSER?
        </Typography> */}

        <Box display='flex' alignItems='center' mt={2}>
          <Box
            flex={1}
            height='1px'
            sx={{ background: 'linear-gradient(to right, transparent, #ccc)' }}
          />

          <Typography variant='caption' sx={{ mx: 2, textTransform: 'uppercase', color: '#555' }}>
            ¿Sos nuevo?
          </Typography>

          <Box
            flex={1}
            height='1px'
            sx={{ background: 'linear-gradient(to left, transparent, #ccc)' }}
          />
        </Box>

        <LoadingButton
          component={RouterLink}
          to={'/crear-cuenta-mobile'}
          variant='contained'
          // size='small'
          color='neutral'
          disableElevation
        >
          Crear Cuenta
        </LoadingButton>

        {/* Botón Descargar App */}
        <ButtonDownloadPWA>
          <BotonDescargaApp
            arialLabel={'Instalar Aplicación. Acceso rápido desde tu pantalla de inicio.'}
            content={
              <Typography variant='body2'>
                <b>Instalar Aplicación</b> <br />
                Acceso rápido desde tu pantalla de inicio.
              </Typography>
            }
          />
        </ButtonDownloadPWA>
        <ButtonDownloadPWAiOS isMobile>
          <BotonDescargaApp
            arialLabel={'¿Cómo instalar mi.OSER en dispositivos Apple?'}
            content={
              <Typography variant='body2'>
                ¿Cómo <b>Instalar Aplicación</b>? <br />
                Acceso rápido desde tu pantalla de inicio.
              </Typography>
            }
          />
        </ButtonDownloadPWAiOS>
      </Box>

      <CustomizedSnackbars
        open={response}
        severity='success'
        message={response}
        onDeleteMessage={handleBorrarMensaje}
      />
    </>
  );
};
